import { EnvMicroReport } from 'lib-klab-core';

export const envReportLocal: EnvMicroReport = {
    host: '',
    apiBasePath: '/ms-report',
    vars: {},
    useMocks: false,
    mock: {
        appActivityReports: {
            getAppActivitiesList: false,
            getAppsTopWithPercentage: false,
        },
        webActivityReports: {
            getWebActivitiesList: false,
            getWebsTopWithPercentage: false,
        },
        connectivityReports: {
            getConnectivityReport: false,
        },
        timeSheetReports: {
            getTimeSheet: false,
        },
        admin: {
            getAdminTimesheetsList: false,
            getOrganizationProductivity: false,
            getEmployeeProductivity: false,
            getAdminDownloadList: false,
            getAdminDownloadEmployee: false,
            getEmployeeProductivityMetrics: false,
            getOrganizationProductivityMetrics: false,
            exportAdminTimesheetsList: false,
            exportAdminDownloadList: false,
            exportAdminDownloadEmployee: false,
            exportProductivityEmployees: false,
            exportProductivityLocation: false,
        },
        adminDashboard: {
            getEmployeeSummary: false,
            getActivityBreakdown: false,
            getUsageWebsTop: false,
            getUsageAppsTop: false,
            getUsageWebsHistory: false,
            getUsageAppsHistory: false,
            getProductivityDepartments: false,
            getProductivityLocations: false,
            getProductivityEmployeesTop: false,
            getProductivityEmployeesBottom: false,
            getProductivityEmployeesTopHistory: false,
            getProductivityEmployeesBottomHistory: false,
        },
    },
};

export const envReportDev: EnvMicroReport = {
    host: 'https://gatewayapi-dev.klab.inclub.world',
    apiBasePath: '/ms-report',
    vars: {},
    useMocks: false,
    mock: {
        appActivityReports: {
            getAppActivitiesList: false,
            getAppsTopWithPercentage: false,
        },
        webActivityReports: {
            getWebActivitiesList: false,
            getWebsTopWithPercentage: false,
        },
        connectivityReports: {
            getConnectivityReport: false,
        },
        timeSheetReports: {
            getTimeSheet: false,
        },
        admin: {
            getAdminTimesheetsList: false,
            getOrganizationProductivity: false,
            getEmployeeProductivity: false,
            getAdminDownloadList: false,
            getAdminDownloadEmployee: false,
            getEmployeeProductivityMetrics: false,
            getOrganizationProductivityMetrics: false,
            exportAdminTimesheetsList: false,
            exportAdminDownloadList: false,
            exportAdminDownloadEmployee: false,
            exportProductivityEmployees: false,
            exportProductivityLocation: false,
        },
        adminDashboard: {
            getEmployeeSummary: false,
            getActivityBreakdown: false,
            getUsageWebsTop: false,
            getUsageAppsTop: false,
            getUsageWebsHistory: false,
            getUsageAppsHistory: false,
            getProductivityDepartments: false,
            getProductivityLocations: false,
            getProductivityEmployeesTop: false,
            getProductivityEmployeesBottom: false,
            getProductivityEmployeesTopHistory: false,
            getProductivityEmployeesBottomHistory: false,
        },
    },
};

export const envReportProd: EnvMicroReport = {
    host: 'https://gatewayapi.klab.inclub.world',
    apiBasePath: '/ms-report',
    vars: {},
    useMocks: false,
};
